"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNDItemWrapper = void 0;
var CustomDraggableItem_1 = require("./CustomDraggableItem");
var react_1 = __importDefault(require("react"));
var style_1 = require("./style");
var CustomHooks_1 = require("../CustomHooks");
var DNDItemWrapper = function (props) {
    var onClick = props.onClick, onDoubleClick = props.onDoubleClick, className = props.className, providedDraggable = props.providedDraggable, item = props.item, handleHelpButtonClicked = props.handleHelpButtonClicked, displayButtons = props.displayButtons, value = props.value, selectedItemHelpButtons = props.selectedItemHelpButtons, disabled = props.disabled;
    var _a = (0, CustomHooks_1.useClickPreventionOnDoubleClick)(onClick, onDoubleClick), handleClick = _a[0], handleDoubleClick = _a[1];
    return (react_1.default.createElement(style_1.DNDItemBody, { disabled: disabled },
        react_1.default.createElement(style_1.DNDItem, __assign({ onClick: handleClick, onDoubleClick: handleDoubleClick, className: className, disabled: disabled, ref: props.innerRef }, providedDraggable.draggableProps, providedDraggable.dragHandleProps, { style: __assign({}, (providedDraggable.draggableProps.style || {})) }),
            react_1.default.createElement(CustomDraggableItem_1.CustomDraggableItem, { label: item.label, type: item.type || '', source: value.id, displayButtons: displayButtons, selectedItemHelpButtons: selectedItemHelpButtons, draggableId: item.value, handleHelpButtonClicked: handleHelpButtonClicked }),
            providedDraggable.placeholder)));
};
exports.DNDItemWrapper = DNDItemWrapper;
